/* eslint max-classes-per-file: 0 */

import {
  Getters,
  Mutations,
  Actions,
  Module,
  createMapper,
} from 'vuex-smart-module'


type S = RootState
type G = RootGetters
type M = RootMutations
type A = RootActions

class RootState {
}

class RootGetters extends Getters<S> {
}

class RootMutations extends Mutations<S> {
}

class RootActions extends Actions<S, G, M, A> {
}

export const storeModule = new Module({
  namespaced: false,
  state: RootState,
  getters: RootGetters,
  mutations: RootMutations,
  actions: RootActions,
})

const mapper = createMapper(storeModule)

export {
  storeModule as rootStoreModule,
  mapper as rootMapper,
}
